import PropTypes from "prop-types";
import React from "react";
import HeaderTab from "../HeaderTab/HeaderTab";

const IconTab = (props) => (
    <HeaderTab {...props}>
        {({isActive}) => {
            return (
                <React.Fragment>
                    {typeof props.icon === "string" ? (
                        <span className={props.icon} />
                    ) : (
                        props.icon(isActive)
                    )}
                    {props.children}
                </React.Fragment>
            );
        }}
    </HeaderTab>
);

IconTab.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]).isRequired,
    onClick: PropTypes.func.isRequired,
    to: PropTypes.string.isRequired,
};

IconTab.defaultProps = {
    onClick: () => {},
};

export default IconTab;
